import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CreditManagerGuard implements CanActivate {
  constructor(
    private keycloakAngular: KeycloakService,
    private router: Router,
  ){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if(!this.keycloakAngular.getUserRoles().includes('ROLE_CO') && !this.keycloakAngular.getUserRoles().includes('ROLE_CR') && !this.keycloakAngular.getUserRoles().includes('ROLE_CD') ){
        this.router.navigate(['/dashboard'])
      }
            
    return this.keycloakAngular.getUserRoles().includes('ROLE_CO') || this.keycloakAngular.getUserRoles().includes('ROLE_CR') || this.keycloakAngular.getUserRoles().includes('ROLE_CD');
  }
  
}
